$(document).ready(function(){
  let $slider = $('.hotspot-products-slider');
  let positionSet = false;
  
  if ($slider.length && !$slider.hasClass('slick-initialized')) {
    $slider.slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      adaptiveHeight: false,
      swipe: true,
      touchMove: false,
      touchThreshold: 10,
      swipeToSlide: true,
      prevArrow: `<button type="button" class="slick-prev hotspot-products-slider__prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg></button>`,
      nextArrow: `<button type="button" class="slick-next hotspot-products-slider__next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg></button>`,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
    
    if (window.theme && window.theme.productBlockManager) {
      let originalAlignHeights = window.theme.productBlockManager.alignProductBlockHeights;
      window.theme.productBlockManager.alignProductBlockHeights = function(container) {
        if (!$(container).closest('.hotspot-products-slider').length) {
          originalAlignHeights.call(this, container);
        }
      };
      window.theme.productBlockManager.loadImages($slider[0]);
      window.theme.productBlockManager.alignProductBlockHeights = originalAlignHeights;
    }
  }

  $(document).on('click', '.image-with-links-hotspot-button', function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!positionSet) {
      setTimeout(function() {
        $('.hotspot-products-slider').slick('setPosition');
        positionSet = true;
      }, 350);
    }
  });
}); 